import React from 'react';
import ContentLoader from 'react-content-loader';

const OrderStatusTrackingLoader = (props: any) => (
    <ContentLoader
        speed={2}
        width={1000}
        height={180}
        viewBox="0 0 1000 180"
        backgroundColor="#fff"
        foregroundColor="#ccc"
        title="Bezig met laden..."
        {...props}
    >
        {/*title */}
        <rect x="30" y="10" rx="0" ry="0" width="118" height="14" />

        <rect x="9" y="50" rx="2" ry="2" width="997" height="1" />

        {/*status*/}
        <rect x="30" y="75" rx="0" ry="0" width="300" height="10" />

        {/*toppybox*/}
        <rect x="30" y="100" rx="3" ry="3" width="25" height="18" />
        {/*progressbar*/}
        <rect x="30" y="108" rx="0" ry="0" width="950" height="3" />

        <rect x="6" y="140" rx="2" ry="2" width="997" height="1" />

        {/*products*/}
        <rect x="450" y="160" rx="0" ry="0" width="150" height="15" />
    </ContentLoader>
);

export default OrderStatusTrackingLoader;
